import React from 'react';
import { SectionWrapper } from '../ui/SectionWrapper';
import { FadeUp } from '../ui/FadeUp';
export function PainSection() {
  const painPoints = ['Conversaciones que <strong class="text-plum font-medium">alteran tu estado</strong> y no podés sacarte de encima', 'Llegar a casa y seguir <strong class="text-plum font-medium">"enganchada"</strong> en lo que pasó', '<strong class="text-plum font-medium">Reaccionar</strong> más de lo que querés, sin poder frenarte', 'Sentirte <strong class="text-plum font-medium">menos estable</strong> que antes, aunque externamente todo va bien'];
  return <SectionWrapper bgColor="sand" id="pain" data-id="element-161">
      <FadeUp data-id="element-162">
        <h2 className="text-[clamp(28px,8vw,40px)] text-center mb-2" data-id="element-163">
          ¿Te <em className="font-serif italic text-plum" data-id="element-164">identificás?</em>
        </h2>
      </FadeUp>

      <FadeUp delay={0.1} data-id="element-165">
        <p className="text-center text-[13px] text-muted mb-9" data-id="element-166">
          Si alguna vez sentiste esto, estás en el lugar correcto
        </p>
      </FadeUp>

      <FadeUp delay={0.2} data-id="element-167">
        <ul className="flex flex-col gap-3" data-id="element-168">
          {painPoints.map((point, index) => <li key={index} className="bg-white border-l-[3px] border-plum py-3 px-4 rounded-r-[6px] text-[14px] text-charcoal flex items-center gap-3" data-id="element-169">
              <span className="text-[28px] text-plum leading-none flex-shrink-0" data-id="element-170">
                ·
              </span>
              <span dangerouslySetInnerHTML={{
            __html: point
          }} data-id="element-171" />
            </li>)}
        </ul>
      </FadeUp>

      <FadeUp delay={0.3} data-id="element-172">
        <div className="bg-ivory rounded-[8px] p-[18px] text-[13px] text-charcoal leading-[1.65] text-center mt-8" data-id="element-173">
          <strong className="font-serif text-[17px] block mb-1.5 font-medium" data-id="element-174">
            Las mujeres más responsables son las que más absorben lo que no es
            suyo.
          </strong>
          No porque sean débiles. Sino porque nadie les enseñó a regular.
        </div>
      </FadeUp>
    </SectionWrapper>;
}